import { request } from '@umijs/max';
import {
  ActionResultData,
  AreaVo,
  BatchDeleteInput5,
  BatchDisablePayload5,
  BatchEnableBody10,
  BatchHiddenBody8,
  BatchSetOrderPayload6,
  BatchShowInput4,
  PagerDataSysRegion,
  SaveTagsBody8,
  SetOrderBody6,
  SysRegion,
  SysRegionNode,
  SysRegionRequest,
  TagInfo,
  UploadVo,
} from '../AdminTypings';

export namespace AdminSysRegion {
  /**
   * @summary 保存数据标签
   * @secure
   */
  export const saveTags = async (
    id: number,
    data: SaveTagsBody8,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/tag/save/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 设置排序权重
   * @secure
   */
  export const setOrder = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    data: SetOrderBody6,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/set/order/${pkg}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 查询列表
   * @secure
   */
  export const query = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: SysRegionRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysRegion[]>(`/admin/sys/region/query/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 分页列表
   * @secure
   */
  export const list = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: SysRegionRequest,
    params: { [key: string]: any } = {},
  ) => {
    return request<PagerDataSysRegion>(`/admin/sys/region/list/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 编辑地区
   * @secure
   */
  export const edit = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    data: SysRegion,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/edit/${pkg}/${pid}/${id}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 新建地区
   * @secure
   */
  export const create = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: SysRegion,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/create/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量显示
   * @secure
   */
  export const batchShow = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchShowInput4,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/show/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量设置排序权重
   * @secure
   */
  export const batchSetOrder = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchSetOrderPayload6,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/set/order/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量隐藏
   * @secure
   */
  export const batchHidden = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchHiddenBody8,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/hidden/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量启用
   * @secure
   */
  export const batchEnable = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchEnableBody10,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/enable/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量禁用
   * @secure
   */
  export const batchDisable = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchDisablePayload5,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/disable/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 批量删除
   * @secure
   */
  export const batchDelete = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    data: BatchDeleteInput5,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/batch/delete/${pkg}/${pid}`, {
      method: 'POST',
      data: data,
      ...params,
    });
  };

  /**
   * @summary 地区树
   * @secure
   */
  export const treeNode = async (pkg: 'ZH' | 'USA', params: { [key: string]: any } = {}) => {
    return request<SysRegionNode[]>(`/admin/sys/region/tree/${pkg}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据可用标签
   * @secure
   */
  export const getTagList = async (id: number, params: { [key: string]: any } = {}) => {
    return request<TagInfo[]>(`/admin/sys/region/tag/list/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 获取数据标签
   * @secure
   */
  export const getTags = async (id: number, params: { [key: string]: any } = {}) => {
    return request<string[]>(`/admin/sys/region/tag/get/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 静态 tree
   * @secure
   */
  export const staticTree = async (pkg: 'ZH' | 'USA', params: { [key: string]: any } = {}) => {
    return request<UploadVo>(`/admin/sys/region/static/tree/${pkg}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 显示
   * @secure
   */
  export const show = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/show/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 地区路径
   * @secure
   */
  export const regionPath = async (id: number, params: { [key: string]: any } = {}) => {
    return request<SysRegion[]>(`/admin/sys/region/path/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 隐藏
   * @secure
   */
  export const hidden = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/hidden/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 启用
   * @secure
   */
  export const enable = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/enable/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 禁用
   * @secure
   */
  export const disable = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/disable/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 详情
   * @secure
   */
  export const detail = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<SysRegion>(`/admin/sys/region/detail/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 删除
   * @secure
   */
  export const remove = async (
    pkg: 'ZH' | 'USA',
    pid: number,
    id: number,
    params: { [key: string]: any } = {},
  ) => {
    return request<ActionResultData>(`/admin/sys/region/delete/${pkg}/${pid}/${id}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 整理数据
   * @secure
   */
  export const collate = async (pkg: 'ZH' | 'USA', params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/region/collate/${pkg}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 缓存 tree
   * @secure
   */
  export const cacheTree = async (pkg: 'ZH' | 'USA', params: { [key: string]: any } = {}) => {
    return request<ActionResultData>(`/admin/sys/region/cache/tree/${pkg}`, {
      method: 'GET',
      ...params,
    });
  };

  /**
   * @summary 地区信息
   * @secure
   */
  export const regionArea = async (id: number, params: { [key: string]: any } = {}) => {
    return request<AreaVo>(`/admin/sys/region/area/${id}`, {
      method: 'GET',
      ...params,
    });
  };
}

export default AdminSysRegion;

export const saveTags = AdminSysRegion.saveTags;
export const setOrder = AdminSysRegion.setOrder;
export const query = AdminSysRegion.query;
export const list = AdminSysRegion.list;
export const edit = AdminSysRegion.edit;
export const create = AdminSysRegion.create;
export const batchShow = AdminSysRegion.batchShow;
export const batchSetOrder = AdminSysRegion.batchSetOrder;
export const batchHidden = AdminSysRegion.batchHidden;
export const batchEnable = AdminSysRegion.batchEnable;
export const batchDisable = AdminSysRegion.batchDisable;
export const batchDelete = AdminSysRegion.batchDelete;
export const treeNode = AdminSysRegion.treeNode;
export const getTagList = AdminSysRegion.getTagList;
export const getTags = AdminSysRegion.getTags;
export const staticTree = AdminSysRegion.staticTree;
export const show = AdminSysRegion.show;
export const regionPath = AdminSysRegion.regionPath;
export const hidden = AdminSysRegion.hidden;
export const enable = AdminSysRegion.enable;
export const disable = AdminSysRegion.disable;
export const detail = AdminSysRegion.detail;
export const remove = AdminSysRegion.remove;
export const collate = AdminSysRegion.collate;
export const cacheTree = AdminSysRegion.cacheTree;
export const regionArea = AdminSysRegion.regionArea;
